<template>
  <v-container fluid class="pa-4 pt-1">
    <v-col class="pt-0">
      <!-- Dashboard Title -->
      <v-row class="d-flex align-center py-0 my-0 mb-2">
        <v-col md="6" class="py-0" style="color: #23468c; font-weight: 500">
          Pas Dashboard
        </v-col>
        <v-col md="6" class="text-right py-0">
          {{ time() }}
        </v-col>
      </v-row>

      <!-- Metrics Cards -->

      <!-- Search Section -->

      <v-card rounded="lg" elevation="3">
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          class="px-2 py-2"
        >
          <!-- SEARCH Text on the Left Side -->
          <v-col cols="auto" class="mr-6">
            <span class="text-subtitle-1 primary--text font-weight-medium"
              >SEARCH</span
            >
          </v-col>

          <!-- Right-Side Fields and Button -->
          <v-row no-gutters align="center" class="d-flex" justify="end">
            <!-- Search by Text -->
            <v-col cols="auto" class="mr-3">
              <span class="text-body-2 grey--text text--darken-1"
                >Search by:</span
              >
            </v-col>
            <v-col cols="auto" class="mr-3">
              <v-select
                v-model="selectedWarehouse"
                :items="warehousees"
                label="Warehouse Facility"
                outlined
                dense
                hide-details
                @change="getData(selectedWarehouse)"
              ></v-select>
            </v-col>
            <!-- Driver Name Search -->
            <v-col cols="auto" class="mr-3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    dense
                    hide-details
                    @click:clear="clearDateInput('this.from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Search Button -->
            <v-col cols="auto">
              <v-btn
                color="primary"
                height="32"
                width="100"
                class="text-none font-weight-medium"
                rounded
                @click="getData"
              >
                SEARCH
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-card>

      <v-row class="mt-1">
        <!-- Inbound Column -->
        <v-col cols="12" lg="6">
          <v-card outlined>
            <v-row class="align-center justify-center text-center pt-4">
              <v-icon color="amber darken-2" class=""
                >mdi-truck-cargo-container</v-icon
              >
              <span
                class="text-subtitle-1 align-center primary--text font-weight-medium pl-2"
                >Inbound</span
              >
            </v-row>
            <v-row class="ml-1 mr-1 pt-0">
              <!-- Total Trucks -->
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="amber lighten-4" size="25" class="mr-2">
                    <v-icon color="amber darken-2">mdi-truck</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold primary--text">
                      {{ inboundDatas.projection_pallet }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Projected Pallet
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- Trucks in Plant -->
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="teal lighten-4" size="25" class="mr-2">
                    <v-icon color="teal">mdi-warehouse</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold teal--text">
                      {{ inboundDatas.projection_quantity }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Projected Qty
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- Trucks in Transit -->
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="purple lighten-4" size="25" class="mr-2">
                    <v-icon color="purple">mdi-truck-fast</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold purple--text">
                      {{ inboundDatas.actual_pallet }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Actual Pallet
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="purple lighten-4" size="25" class="mr-2">
                    <v-icon color="purple">mdi-truck-fast</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold purple--text">
                      {{ inboundDatas.actual_quantity }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Actual Qty
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-card outlined>
                    <v-data-table
                      :headers="headers"
                      :items="inboundData"
                      disable-pagination
                      hide-default-footer
                      class="custom-table"
                      fixed-header
                      :height="280"
                    >
                    </v-data-table>
                  </v-card>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-card outlined>
                    <v-data-table
                      class="custom-table"
                      :headers="headersStorer"
                      :items="transformedData"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                      :height="280"
                    ></v-data-table>
                  </v-card>
                </v-col>
                <v-row class="pl-3 pb-3 mr-1">
                  <!-- Total Trucks -->
                  <v-col cols="6" sm="6">
                    <v-card class="pa-4 d-flex align-center" height="50">
                      <v-avatar color="amber lighten-4" size="25" class="mr-2">
                        <v-icon color="amber darken-2">mdi-truck</v-icon>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold primary--text">
                          {{ inboundDatas.loose_count }}
                        </div>
                        <div class="grey--text" style="font-size: 12px">
                          Loose Count
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-card class="pa-4 d-flex align-center" height="50">
                      <v-avatar color="amber lighten-4" size="25" class="mr-2">
                        <v-icon color="amber darken-2">mdi-truck</v-icon>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold primary--text">
                          {{ inboundDatas.pallet_count }}
                        </div>
                        <div class="grey--text" style="font-size: 12px">
                          Pallet Count
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card class="text-center mx-3">
                  <div
                    v-for="(
                      details, doorName
                    ) in inboundDatas.dock_number_details"
                    :key="doorName"
                    class="door-circle-wrapper"
                  >
                    <div
                      class="position-relative d-inline-block"
                      :class="['door-circle', getCircleColor(details)]"
                      style="width: 60px; height: 60px; padding-top: 10px"
                    >
                      <!-- Badge positioned in top-right corner, text inside the circle -->
                      <v-badge
                        color="red"
                        :content="details.length"
                        overlap
                        class="badge-position"
                        v-if="details.length > 0"
                      ></v-badge>

                      <!-- Centered Door Name Text -->
                      <span>{{ doorName.toUpperCase() }}</span>
                    </div>
                  </div>
                </v-card>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Outbound Column -->
        <v-col cols="12" lg="6">
          <v-card outlined>
            <v-row class="align-center justify-center text-center pt-4">
              <v-icon color="amber darken-2" class=""
                >mdi-truck-fast-outline</v-icon
              >
              <span
                class="text-subtitle-1 align-center primary--text font-weight-medium pl-2"
                >Outbound</span
              >
            </v-row>
            <v-row class="ml-1 mr-1">
              <!-- Total Trucks -->
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="amber lighten-4" size="25" class="mr-2">
                    <v-icon color="amber darken-2">mdi-truck</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold primary--text">
                      {{ outboundDatas.projection_pallet }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Projected Pallet
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="teal lighten-4" size="25" class="mr-2">
                    <v-icon color="teal">mdi-warehouse</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold teal--text">
                      {{ outboundDatas.projection_quantity }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Projected Qty
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="purple lighten-4" size="25" class="mr-2">
                    <v-icon color="purple">mdi-truck-fast</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold purple--text">
                      {{ outboundDatas.actual_pallet }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Actual Pallet
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3" class="pt-0">
                <v-card class="pa-1 d-flex align-center" height="50">
                  <v-avatar color="purple lighten-4" size="25" class="mr-2">
                    <v-icon color="purple">mdi-truck-fast</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold purple--text">
                      {{ outboundDatas.actual_quantity }}
                    </div>
                    <div class="grey--text" style="font-size: 12px">
                      Actual Qty
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-card outlined>
                    <v-data-table
                      :headers="headers"
                      :items="outboundData"
                      disable-pagination
                      hide-default-footer
                      class="custom-table"
                      fixed-header
                      :height="280"
                    >
                    </v-data-table>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-card outlined>
                    <v-data-table
                      class="custom-table"
                      :headers="headersStorer"
                      :items="transformedDataOutbound"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                      :height="280"
                    >
                    </v-data-table>
                  </v-card>
                </v-col>
                <v-row class="pl-3 pb-3 mr-1">
                  <!-- Total Trucks -->
                  <v-col cols="6" sm="6">
                    <v-card class="pa-4 d-flex align-center" height="50">
                      <v-avatar color="amber lighten-4" size="25" class="mr-2">
                        <v-icon color="amber darken-2">mdi-truck</v-icon>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold primary--text">
                          {{ outboundDatas.loose_count }}
                        </div>
                        <div class="grey--text" style="font-size: 12px">
                          Loose Count
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-card class="pa-4 d-flex align-center" height="50">
                      <v-avatar color="amber lighten-4" size="25" class="mr-2">
                        <v-icon color="amber darken-2">mdi-truck</v-icon>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold primary--text">
                          {{ outboundDatas.pallet_count }}
                        </div>
                        <div class="grey--text" style="font-size: 12px">
                          Pallet Count
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card class="text-center mx-3">
                  <div
                    v-for="(
                      details, doorName
                    ) in outboundDatas.dock_number_details"
                    :key="doorName"
                    class="door-circle-wrapper"
                  >
                    <div
                      class="position-relative d-inline-block"
                      :class="['door-circle', getCircleColor(details)]"
                      style="width: 60px; height: 60px; padding-top: 10px"
                    >
                      <v-badge
                        color="red"
                        :content="details.length"
                        overlap
                        class="badge-position"
                        v-if="details.length > 0"
                      ></v-badge>
                      <span>{{ doorName.toUpperCase() }}</span>
                    </div>
                  </div>
                </v-card>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isloading: false,

      search: {
        driverName: "",
        truckNumber: "",
        uidNumber: "",
      },
      to_date: null,
      from_date: null,
      dateMenu: false,
      dateMenuTo: false,
      transformedWarehouses: {},
      selectedWarehouse: "",
      currentGroupIndex: 0,
      currentWarehouseIndex: { RSACC: 0, RSAL: 0 },
      intervalId: null,
      inboundDatas: {},
      outboundDatas: {},
      headers: [
        {
          text: "Type of Vehicle",
          value: "name",
          align: "left",
          sortable: false,
        },
        {
          text: "No of Vehicle",
          value: "count",
          align: "left",
          sortable: false,
        },
      ],
      headersStorer: [
        {
          text: "Storer",
          value: "storer_name",
          align: "left",
          sortable: false,
          width: "10px",
        },
        {
          text: "Vehicle",
          value: "vehicle_type",
          align: "left",
          sortable: false,
          width: "10px",
        },
        {
          text: "No of Vehicle",
          value: "vehicle_count",
          align: "left",
          sortable: false,
          width: "10px",
        },
      ],
      inboundData: [],
      transformedData: [],
      transformedDataOutbound: [],
      outboundData: [],
      warehousees: [],
    };
  },
  computed: {
    getDynamicMaxHeight() {
      // Adjust height based on the number of items (you can customize the logic as needed)
      let itemCount = this.inboundData.length;
      let maxHeight = itemCount <= 9 ? `${itemCount * 30}px` : "300px"; // Change '30px' based on your row height and adjust for your needs
      return maxHeight;
    },
  },
  created() {
    // this.getData();
  },
  async mounted() {
    await this.fetchStorelist().then((res) => {
      this.warehousees = res.data.warehouses.map((obj) => Object.keys(obj)[0]);
      this.warehouseesList = res.data.warehouses;
    });
    await this.transformWarehouses();
    await this.selectNextWarehouse();
    this.intervalId = setInterval(this.selectNextWarehouse, 600000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions(["bargraphData", "fetchStorelist"]),
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    getCircleColor(since) {
      if (since) {
        for (let entry of since) {
          const since = entry.since;
          const hourMatch = since.match(/(\d+)\s*hours?/);
          let value = hourMatch ? parseInt(hourMatch[1], 10) : 0;
          if (value > 2) {
            return "red-blinking";
          } else {
            if (since.alert_flag == 0) {
              return "orange";
            } else {
              return "green";
            }
          }
        }
      }
      if (since.length == 0) {
        return "green";
      }
    },

    time() {
      const currentDate = new Date();
      const options = {
        timeZone: "Asia/Dubai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // Use "true" for 12-hour format or "false" for 24-hour format
      };
      let uaeTimeString = currentDate.toLocaleString("en-GB", options);

      // Convert the AM/PM part to uppercase
      uaeTimeString = uaeTimeString.replace(/\b(am|pm)\b/i, (match) =>
        match.toUpperCase()
      );

      return uaeTimeString;
    },
    async transformWarehouses() {
      const result = {};
      await this.warehouseesList.forEach((warehouseObj) => {
        const [warehouseCode, details] = Object.entries(warehouseObj)[0];
        const groupKey = details.name;
        if (!result[groupKey]) {
          result[groupKey] = [];
        }
        result[groupKey].push(warehouseCode);
      });
      this.transformedWarehouses = result;
    },
    selectNextWarehouse() {
      const groupKeys = Object.keys(this.transformedWarehouses);
      const currentGroup = groupKeys[this.currentGroupIndex];
      const groupWarehouses = this.transformedWarehouses[currentGroup];

      // Select the warehouse based on the current index in the group
      this.selectedWarehouse =
        groupWarehouses[this.currentWarehouseIndex[currentGroup]];
      // Update the index for the current group
      this.currentWarehouseIndex[currentGroup] =
        (this.currentWarehouseIndex[currentGroup] + 1) % groupWarehouses.length;

      // Switch to the other group for the next call
      this.currentGroupIndex = (this.currentGroupIndex + 1) % groupKeys.length;

      this.getData(this.selectedWarehouse);
    },
    getData() {
      this.isloading = true;
      if (!this.from_date) {
        const currentDate = new Date();
        this.from_date = currentDate.toISOString().split("T")[0]; // Use only the date part
      }
      let payload = {
        warehouse_name: this.selectedWarehouse,
        report_date: this.from_date,
      };
      this.bargraphData(payload)
        .then((response) => {
          this.inboundDatas = response.data.inbound;
          this.outboundDatas = response.data.outbound;
          this.vehicleData = response.data.inbound.vehicle_details;

          this.inboundData = Object.entries(this.vehicleData).map(
            ([name, count]) => ({
              name,
              count,
            })
          );
          this.outboundData = Object.entries(
            response.data.outbound.vehicle_details
          ).map(([name, count]) => ({
            name,
            count,
          }));

          this.transformedData = [];
          for (const [storer_name, vehicles] of Object.entries(
            response.data.inbound.storer_details
          )) {
            for (const [vehicle_type, vehicle_count] of Object.entries(
              vehicles
            )) {
              this.transformedData.push({
                storer_name,
                vehicle_type,
                vehicle_count,
              });
            }
          }
          this.transformedDataOutbound = [];
          for (const [storer_name, vehicles] of Object.entries(
            response.data.outbound.storer_details
          )) {
            for (const [vehicle_type, vehicle_count] of Object.entries(
              vehicles
            )) {
              this.transformedDataOutbound.push({
                storer_name,
                vehicle_type,
                vehicle_count,
              });
            }
          }
          this.isloading = false;

          // this.chartData.datasets[0].data = Object.values(this.vehicleData);
          // this.chartData = response.data;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>
<style scoped>
/* Optional: Make sure the table rows are scrollable */
.v-data-table__wrapper {
  overflow-y: auto;
  max-height: 300px; /* Adjust based on your requirement */
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 35px !important;
}
/* Sticky header style */
th {
  position: sticky;
  top: 0;
  background-color: white; /* Make background solid */
  z-index: 1; /* Ensure header stays on top of table rows */
  font-weight: bold; /* Optional: Make header text bold */
}

.door-circle-wrapper {
  display: inline-block;
  margin: 10px;
  text-align: center;
}

.door-circle {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 12px;
}

/* Green circle style */
.green {
  background-color: green;
}

/* Red circle with blinking effect */
.red-blinking {
  background-color: red;
  animation: blink 1s infinite;
}

/* Blinking animation */
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.sticky-header-table .v-data-table-header {
  position: sticky;
  top: 0;
  background-color: white; /* Adjust based on your card's color */
  z-index: 1;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
  padding: 4px !important;
  min-width: 50px;
  white-space: nowrap;
}
.v-card {
  border-radius: 8px !important;
}
.v-avatar {
  border-radius: 12px !important;
}
.v-text-field ::v-deep .v-label {
  font-size: 14px !important;
  top: 6px !important;
}

/* Card shadow and border */
.v-card {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e0e0e0;
}
.v-text-field ::v-deep .v-input__append-inner {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.v-text-field ::v-deep .v-input__icon--append .v-icon {
  font-size: 18px;
  color: #666;
}
.v-data-table__wrapper > table > tbody > tr > td {
  font-size: 0.875rem !important; /* Adjust font size here */
  height: 35px !important;
}
.custom-table .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 0.875rem !important;
  height: 35px !important;
}

/* Adjust input text and label size */
.v-text-field ::v-deep input {
  font-size: 14px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.door-circle-wrapper .badge-position {
  position: absolute;
  top: -4px;
  right: -5px;
  transform: translate(50%, -50%);
}
.v-badge__badge {
  border-radius: 10px;
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  height: 22px;
  letter-spacing: 0;
  line-height: 1;
  min-width: 22px;
  padding: 4px 6px;
  pointer-events: auto;
  position: absolute;
}

.door-circle-wrapper .door-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 2px solid #ccc; /* Customize as needed */
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styles to hide the content when the loader is active */
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}

/* Styles for the loader itself */
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}
</style>
